import type { SingleResponse } from "../../tastyworks"
import { ENTITY_DESER, Entity } from "../../tastyworks/entity"
import type HttpClient from "../../tastyworks/http"

export class EntityService {
  constructor(private readonly httpClient: HttpClient) {}

  readonly create = async (entity: Entity): Promise<SingleResponse<Entity>> =>
    this.httpClient.create(
      entity,
      ENTITY_DESER.serialize,
      ENTITY_DESER.update,
      "/entities"
    )
}
